import { Award, Trophy, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { BonusType, BonusTypeLabels } from "@/types/bonus";

// The same icons the employee home screen uses for each type. A Record, so a
// new BonusType fails to compile until it has one.
const ICONS: Record<BonusType, React.ElementType> = {
  [BonusType.REFERRAL]: Users,
  [BonusType.SEASONAL]: Award,
  [BonusType.INCENTIVE]: Trophy,
};

/**
 * Outlined rather than filled: a filled gold pill means "yours" elsewhere in
 * the app, and next to the amber Archived pill it would be two near-identical
 * yellows.
 */
export function BonusTypePill({
  type,
  className,
}: {
  type: BonusType | string;
  className?: string;
}) {
  const Icon = ICONS[type as BonusType];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-primary/40 px-2 py-1 text-xs font-medium text-foreground",
        className,
      )}
    >
      {Icon && <Icon className="h-3 w-3 text-primary" />}
      {BonusTypeLabels[type as BonusType] ?? type}
    </span>
  );
}
